import { DNDType, ColorPalette } from "./types";

export const NO_STATUS_COLUMN: DNDType = {
  id: 'no-status',

  title: 'Ideas',
  color: 'grey',
  items: [],
};

export const SCHEDULED_COLUMN: DNDType = {
  id: 'scheduled',
  title: 'Scheduled',
  color: 'blue',
  items: [],
};

export const colors: ColorPalette = {
  light: {
    grey: {
      background: '#FAFAFA',
      tagBackground: '#E1E1E1',
      placeholderText: '#999999',
      tagText: '#666666',
    },
    brown: {
      background: '#FBF9F8',
      tagBackground: '#ECE0DB',
      placeholderText: '#B98C79',
      tagText: '#865946',
    },
    orange: {
      background: '#FDFAF6',
      tagBackground: '#F5DFCC',
      placeholderText: '#DE9454',
      tagText: '#AB6121',
    },
    yellow: {
      background: '#FEFCF6',
      tagBackground: '#FAEDCC',
      placeholderText: '#EDBD45',
      tagText: '#BA8A12',
    },
    green: {
      background: '#F9FBF8',
      tagBackground: '#DEECDC',
      placeholderText: '#82B77B',
      tagText: '#4F8448',
    },
    blue: {
      background: '#F8FAFC',
      tagBackground: '#D6E4EE',
      placeholderText: '#6FA0C3',
      tagText: '#3C6D90',
    },
    purple: {
      background: '#FAF8FB',
      tagBackground: '#E6DEED',
      placeholderText: '#9B7BB7',
      tagText: '#684884',
    },
    pink: {
      background: '#FCF8FA',
      tagBackground: '#F1E1E9',
      placeholderText: '#BE7499',
      tagText: '#8B4166',
    },
    red: {
      background: '#FEF7F6',
      tagBackground: '#FAE3DE',
      placeholderText: '#E4694E',
      tagText: '#B2361A',
    },
  },
  dark: {
    grey: {
      background: '#2A2A2A',
      tagBackground: '#404040',
      placeholderText: '#808080',
      tagText: '#BFBFBF',
    },
    brown: {
      background: '#2A2725',
      tagBackground: '#3D332E',
      placeholderText: '#9E7A69',
      tagText: '#BFA193',
    },
    orange: {
      background: '#2A2622',
      tagBackground: '#43352A',
      placeholderText: '#C68250',
      tagText: '#E6A06B',
    },
    yellow: {
      background: '#2A2924',
      tagBackground: '#433D2A',
      placeholderText: '#CCB154',
      tagText: '#E6CD6B',
    },
    green: {
      background: '#252A24',
      tagBackground: '#2E3D2C',
      placeholderText: '#729F6B',
      tagText: '#8FBF89',
    },
    blue: {
      background: '#222629',
      tagBackground: '#2A363F',
      placeholderText: '#5F8CAB',
      tagText: '#7BA8C9',
    },
    purple: {
      background: '#27242A',
      tagBackground: '#362D3D',
      placeholderText: '#8B6DA3',
      tagText: '#A889BF',
    },
    pink: {
      background: '#2A2426',
      tagBackground: '#3D2E35',
      placeholderText: '#A66585',
      tagText: '#BF89A6',
    },
    red: {
      background: '#2A2322',
      tagBackground: '#3D2D2A',
      placeholderText: '#C65F47',
      tagText: '#E67D66',
    },
  }
};